import { render } from "./PayPage.vue?vue&type=template&id=434cdb54"
import script from "./PayPage.vue?vue&type=script&lang=js"
export * from "./PayPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\client\\Aaahsaass - final\\shop-aaahsaass\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__